import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classes from "./Layout.module.css";
import { toggleSidebar } from '../store/slices/sidebarSlice';
import { useNavigate } from 'react-router-dom';

const Layout = ({ children, active }) => {
    const { sidebar } = useSelector(state => state.sidebarSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        navigate(path);
    }

    return (
        <div className={`${classes.container} ${!sidebar && classes.short}`}>
            <div className={`${classes.sidebar} ${!sidebar && classes.short}`}>

                <div className={classes.sidebar_icon}>
                    <div className={classes.circle} onClick={() => {
                        dispatch(toggleSidebar());
                    }}>
                        {!sidebar ? (
                            <i className={`pi pi-arrow-right ${classes.arrow_icon}`}></i>
                        ) : (
                            <i className={`pi pi-arrow-left ${classes.arrow_icon}`}></i>
                        )}
                    </div>
                </div>

                <div className={`${classes.sidebar_header} ${!sidebar && classes.short}`}>
                    <div className={classes.sidebar_logo_container}>
                        <img src="/assets/images/rainboo-logo-bg.png" alt="Rainboo" className={classes.sidebar_logo} />
                    </div>
                    <div className={classes.sidebar_header_text_wrapper}>
                        <p className={classes.sidebar_header_text_primary}>Rainboo Softmate</p>
                        <p className={classes.sidebar_header_text_secondary}>Reporting Dashboard</p>
                    </div>
                </div>

                <div className={classes.sidebar_menu}>
                    <button
                        className={`${classes.tab} ${active == 1 && classes.active}`}
                        onClick={() => handleNavigate("/home")}
                    >
                        <i className={`pi pi-chart-line ${classes.sidebar_bar_icon}`}></i>
                        {/* <FaChartLine className={classes.sidebar_bar_icon} /> */}
                        <span className={`${!sidebar && classes.short_span}`}>
                            Revenue Insights
                        </span>
                    </button>

                </div>

            </div>
            {children}
        </div>
    )
}

export default Layout